import Axios from "axios";
import {
  SET_PRODUCTION_POS_LIST,
  UNSET_PRODUCTION_POS_LIST,
} from "@/store/mutation-types";
import { posResource } from "@/store/api";

// initial state
const state = {
  getProductionPosList: [],
};

const getters = {
  getProductionPosList(state) {
    return state.getProductionPosList;
  },
};

const mutations = {
  [SET_PRODUCTION_POS_LIST](state, data) {
    state.getProductionPosList = data;
  },
  [UNSET_PRODUCTION_POS_LIST](state) {
    state.getProductionPosList = [];
  },
};

const actions = {
  // fetch POS list
  getProductionPosList({ commit }, params) {
    return new Promise((resolve, reject) => {
      Axios.get(posResource, { params })
        .then(response => {
          commit(SET_PRODUCTION_POS_LIST, response.data.data);
          resolve(response);
        })
        .catch(error => {
          commit(UNSET_PRODUCTION_POS_LIST);
          reject(error);
        });
    });
  },

  // save new POS
  saveProductionPos({ commit }, data) {
    commit("SET_LOADING", { color: "primary" });
    return new Promise((resolve, reject) => {
      Axios.post(posResource, data)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING");
        });
    });
  },

  // update existing POS
  updateProductionPos({ commit }, { id, data }) {
    commit("SET_LOADING", { color: "primary" });
    return new Promise((resolve, reject) => {
      const url = `${posResource}/${id}`;
      Axios.put(url, data)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING");
        });
    });
  },

  // optionally, delete POS
  deleteProductionPos({ commit }, id) {
    commit("SET_LOADING", { color: "primary" });
    return new Promise((resolve, reject) => {
      const url = `${posResource}/${id}`;
      Axios.delete(url)
        .then(response => resolve(response))
        .catch(error => reject(error))
        .finally(() => {
          commit("UNSET_LOADING");
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
